var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneAlternative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#726fb3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 127 127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 63.61,
    r: 63.5,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 63.61,
    r: 63.5,
    fillOpacity: 0.2,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.3,87.07c14.51,14.86,30.75,17.08,39.14,17.08,2.83,0,5.13-.24,6.34-.47h.07c.12-.03.21-.04.29-.07,5.01-1.45,8.28-3.48,11.32-7.02.39-.45.95-1.33,1.21-2.06,1.16-2.45,2.92-7.38,1.99-13.56-.02-.15-.06-.29-.11-.45-.25-.82-.8-1.49-1.57-1.89l-11.93-6.04c-3.23-1.63-7.35-.86-10.04,1.89l-6.65,6.78-.35-.11c-2.78-.84-8.28-3.1-13.95-8.69-5.9-5.81-8.21-11.85-8.93-14.18l-.11-.36,6.76-6.65c2.75-2.69,3.53-6.82,1.89-10.04l-6.04-11.94c-1.32-2.62-4.01-4.24-7.01-4.24-1.3,0-2.56.3-3.77.88-5.03,2.45-11.58,7.24-14.17,16.11l-.05.23c-1.62,8.33-.42,28.32,15.67,44.78ZM31.61,43.73l.02-.09c1.99-6.6,7.02-10.23,10.89-12.11,1.08-.51,2.14-.26,2.58.6l6.06,11.97c.44.82.15,1.98-.71,2.82l-6.77,6.66c-1.6,1.56-2.24,3.77-1.67,5.79.77,2.84,3.37,10.23,10.71,17.51,7.25,7.16,14.45,9.66,17.21,10.41,2.05.55,4.27-.09,5.79-1.66l6.68-6.81c.82-.84,1.98-1.12,2.84-.68l10.63,5.38v.36c.14,3.74-.97,6.68-1.65,8.09l-.07.11c-2.39,2.74-5.15,4.55-8.46,5.55l-.12.03c-.88.13-2.7.35-5.19.35-7.41,0-21.76-1.98-34.71-15.23-6.38-6.53-10.74-14.24-12.96-22.93-1.74-6.83-1.72-12.8-1.13-16.12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneAlternative);
export default __webpack_public_path__ + "static/media/phone-alternative.7c992bff90e9cb4d6f7ab5bb1aa0cd75.svg";
export { ForwardRef as ReactComponent };